import { UserIdentity, UserRole } from "@fusion-advantage/backcompat"

export interface UserIdentities {
	authedIdentity: UserIdentity|null
	impersonatingIdentity: UserIdentity|null
}

export const getDisplayIdentity = (ids: UserIdentities): UserIdentity|null => {
	return ids.impersonatingIdentity ?? ids.authedIdentity ?? null
}

// who may open arbitrary encounters by GUID: Manage Encounters,
// and the /encounter/{guid} link
export const canViewAdhocEncounters = (identity: UserIdentity|null): boolean => {
	return Boolean(identity && (
		identity.roles.includes(UserRole.AUDITOR) ||
		identity.roles.includes(UserRole.VIEW_ADHOC_ENCOUNTERS)
	))
}

// generic way to decide wether to show extra non-risky stuff
// to non-clinicians
export const isUserElevated = (identity: UserIdentity) => {
	return (
		identity.roles.includes(UserRole.APP_ADMIN) ||
		identity.roles.includes(UserRole.AUDITOR) ||
		identity.roles.includes(UserRole.PRINT_MEDICAL_RECORDS)
	)
}
